
/**
 * @namespace Global namespace
 */
var revide = {};

$(document).ready(function () {

    if ($(document).width() > 768) {
        SetEqualHeights();
    }

    window.addEventListener('beforeunload', function (e) {
        localStorage.removeItem("initialTime");
    });

    var timeoutPopupCookie = readCookie("timeoutPopupCookie");
    if (!timeoutPopupCookie) {
        var waitTime = 120000; // 2 min
        var executionTime;
        var initialTime = localStorage.getItem("initialTime");
        if (initialTime === null) {
            localStorage.setItem("initialTime", (new Date()).getTime());
            executionTime = waitTime;
        }
        else {
            executionTime = parseInt(initialTime, 10) + waitTime - (new Date()).getTime();
            if (executionTime < 0) executionTime = 0;
        }

        setTimeout(displayPopup, executionTime);
    }

    if (window.location.href.toString().indexOf("medarbetare") !== -1) {
        $.ajax({
            url: "/umbraco/api/Ajax/GetCoworkers/",
            type: "GET",
            data: { city: "Alla", deparment: "Alla" }, //self.maxItemsPerPage },
            dataType: "json",
            success: function (returnData) {
                if (returnData.Data) {
                    //var currentNewsList = ko.mapping.fromJSON(returnData);
                    var regX = /(<([^>]+)>)/ig;
                    var regSpace = "/\s/g";
                    var html = "";

                    var palle = returnData.Data.toString().split('---');

                    var htmlInformation = "";

                    var currentNewsList = JSON.parse(returnData.Data.toString());

                    $(".cont").html("");
                    $(".cont").append(palle[0]);
                    $(".information").html("");
                    $(".information").html(palle[1]);

                    $('.employee-gridder').gridderExpander({
                        showNav: false,
                        scroll: false,
                        animationEasing: false,
                        animationSpeed: 300,
                        onContent: function () {
                            fixWidth();

                            $(window).on('resize', function () {
                                fixWidth();
                            });

                            function fixWidth() {
                                var offset = $('.gridder').offset();
                                var winWidth = $(window).innerWidth();
                                $('.gridder-show').css('marginLeft', '-' + offset.left + 'px');
                                $('.gridder-show').css('width', winWidth + 'px');
                                setTimeout(function () {
                                    $('.gridder-show').css('opacity', 1);
                                }, 1);
                            }
                        }
                    });

                    $('.employee-gridder .gridder-list').matchHeight();


                    // Run match height script
                    pub.matchHeights();


                }


            },
            error: function (e) {

                ////console.log(e.statusText + ": " + e.responseText); //todo: better error handling
            },
            complete: function () {

            }
        });
    }

    ////Check request url and show video

    if (location.href.indexOf("#") != -1) {
        var hashTag = location.href.substr(location.href.indexOf("#"));
        if (hashTag.toLowerCase() == "#showpopup") {
            $('#shorthVideo').click();
        }
    }

    if (getParameterByName('showpopin') == 'video') {
        $('#show-video-after-submit').fancybox().trigger('click');
        console.log("showpopin");
    }
    if (getParameterByName('showpopin') == 'message') {
        $('.form-init').css('display', 'none');
        $('.popup-container, .black-layer').show();
        $('body').css('position', 'fixed');
        $('.form-submitted').css('display', 'block');
    }

    var str = location.href;
    var res = str.split("/");

    if (res.includes('webinars') || res.includes('seminarier') || res.includes('seminarer')) {

        var perfEntries = performance.getEntriesByType('navigation');
        if (perfEntries.length && perfEntries[0].type === 'back_forward') {

            var filter = getFilterCookie('filter');
            var lang = getFilterCookie('lang');
            filterCategories(filter, lang);

        }
    }

    if ($("#video-anchor").length)
    {
        ScrollToVideo();
    }

    var filterActive = "";
    $('.filter-case').addClass('active');

    $('#caseSelectList').change(function () {

        if ($(this).val() == 'All') {
            $('.filter-case').addClass('active');
            filterActive = 'All';
        } else {
            filterCategory($(this).val(), filterActive);
        }

    });

});

function filterCategory(category, filterActive) {

    if (filterActive != category) {

        // reset results list
        $('.filter-case').removeClass('active');

        $('.filter-case').filter('[data-cat="' + category + '"]').addClass('active');

        // reset active filter
        filterActive = category;
    }
}

function ScrollToVideo() {

    if ($(document).width() > 1024) {
        $('#video-anchor').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });
        $("#video-anchor").trigger("click");
    }
    else {
        $("#video-anchor")[0].click();
    }
}
function SetEqualHeights() {
    $('.upper').matchHeight();
    $('.middle').matchHeight();
    $('.bottom').matchHeight();
}

function displayPopup() {

    localStorage.removeItem("initialTime");
    var timeoutPopupCookie = readCookie("timeoutPopupCookie");
    if (!timeoutPopupCookie) {
        createCookie("timeoutPopupCookie", "1", 90);
        showPopup($('#hidden_pp_container').val());
    }
}

function showPopup(id) {
    var ppContainer = "#pp_" + id;
    $(ppContainer + ', .black-layer').show();
}

$('.flarp-video-container').click(function () {
    showPopup($('#hidden_pp_container').val());
});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function closePopup() {

    var timeoutPopupCookie = readCookie("timeoutPopupCookie");
    if (!timeoutPopupCookie)
        createCookie("timeoutPopupCookie", "1", 90);

    $('body').css('position', '');
    $('.popup-container,.black-layer').css('display', 'none');
    $('.form-init').css('display', 'block');
    $('.form-submitted').css('display', 'none');
}

function selectCategories() {

    //Seminarier
    var query = $("#seminarsSelectList").val();
    var lang = $("#language").val();
    setFilterCookie('filter', query);
    setFilterCookie('lang', lang);

    $.ajax({
        url: "/umbraco/api/Ajax/FilterSeminaries/",
        type: "GET",
        data: { category: query, language: lang },
        dataType: "json",
        success: function (returnData) {
            $("#ajax-response").html('');
            var i = 0;

            var getHighest = [];
            var highestValue = 0;

            var newDiv = '<div class="row small-up-1 medium-up-2 large-up-3 wrapper">';
            returnData.Data.forEach(function (item) {
                i++;
                newDiv += '<div class="column item">';
                if (item.ImagePopupText !== null && item.ImagePopupText !== '') {
                    newDiv += '<div class="text-overlay">';
                    newDiv += item.ImagePopupText;
                    newDiv += '</div>';
                }
                if (item.ImageUrl !== null && item.ImageUrl !== '') {
                    newDiv += "<a href='" + item.PageURL + "'>" + "<img src='" + item.ImageUrl + "alt='" + item.ImageAlt + "'></a>";
                }

                newDiv += '<div class="box" id="box_' + item.Id + '">';
                newDiv += '<h3>' + item.Title + '</h3>';
                newDiv += '<p x-ms-format-detection="none">' + item.Text + '</p>';
                newDiv += '<div class="btns">';
                newDiv += '<a href="' + item.PageURL + '" class="btn small">' + item.BtnText + '</a>';
                newDiv += '</div>';
                newDiv += '</div>';
                newDiv += '</div>';

                //Set values
                setTimeout(function () {
                    var currentBoxHeight = "#box_" + item.Id;
                    var height = $(currentBoxHeight).height();
                    getHighest.push({ 'id': item.Id, 'height': height });
                }, 100);

                var windowWidth = $(window).width();
                var breakPoint = 2;

                if (windowWidth >= 425) {
                    if ((i !== 1 && i % breakPoint === 0) || i === returnData.Data.length) {

                        setTimeout(function () {
                            highestValue = 0;

                            //Get the highest value
                            getHighest.forEach(function (_item) {
                                if (_item.height > highestValue) {
                                    highestValue = _item.height;
                                }
                            });

                            highestValue += 140;
                            //Apply them with the highest value
                            getHighest.forEach(function (_item) {
                                var thisId = "#box_" + _item.id;
                                $(thisId).css({ 'height': highestValue + 'px' });
                            });

                            getHighest = [];
                        }, 100);

                    }
                }
            });


            newDiv += '</div>';
            $("#ajax-response").html(newDiv);
        },
        error: function (e) {
            console.log("error");
        },
        complete: function () {
        }
    });
}

function filterCategories(filter, language) {

    //Seminarier
    var query = filter;
    var lang = language;

    $.ajax({
        url: "/umbraco/api/Ajax/FilterSeminaries/",
        type: "GET",
        data: { category: query, language: lang },
        dataType: "json",
        success: function (returnData) {
            $("#ajax-response").html('');
            var i = 0;

            var getHighest = [];
            var highestValue = 0;

            var newDiv = '<div class="row small-up-1 medium-up-2 large-up-3 wrapper">';
            returnData.Data.forEach(function (item) {
                i++;
                newDiv += '<div class="column item">';
                if (item.ImagePopupText !== null && item.ImagePopupText !== '') {
                    newDiv += '<div class="text-overlay">';
                    newDiv += item.ImagePopupText;
                    newDiv += '</div>';
                }
                if (item.ImageUrl !== null && item.ImageUrl !== '') {
                    newDiv += "<a href='" + item.PageURL + "'>" + "<img src='" + item.ImageUrl + "alt='" + item.ImageAlt + "'></a>";
                }

                newDiv += '<div class="box" id="box_' + item.Id + '">';
                newDiv += '<h3>' + item.Title + '</h3>';
                newDiv += '<p x-ms-format-detection="none">' + item.Text + '</p>';
                newDiv += '<div class="btns">';
                newDiv += '<a href="' + item.PageURL + '" class="btn small">' + item.BtnText + '</a>';
                newDiv += '</div>';
                newDiv += '</div>';
                newDiv += '</div>';

                //Set values
                setTimeout(function () {
                    var currentBoxHeight = "#box_" + item.Id;
                    var height = $(currentBoxHeight).height();
                    getHighest.push({ 'id': item.Id, 'height': height });
                }, 100);

                var windowWidth = $(window).width();
                var breakPoint = 2;

                if (windowWidth >= 425) {
                    if ((i !== 1 && i % breakPoint === 0) || i === returnData.Data.length) {

                        setTimeout(function () {
                            highestValue = 0;

                            //Get the highest value
                            getHighest.forEach(function (_item) {
                                if (_item.height > highestValue) {
                                    highestValue = _item.height;
                                }
                            });

                            highestValue += 140;
                            //Apply them with the highest value
                            getHighest.forEach(function (_item) {
                                var thisId = "#box_" + _item.id;
                                $(thisId).css({ 'height': highestValue + 'px' });
                            });

                            getHighest = [];
                        }, 100);

                    }
                }
            });


            newDiv += '</div>';
            $("#ajax-response").html(newDiv);
        },
        error: function (e) {
            console.log("error");
        },
        complete: function () {
        }
    });
}

function setFilterCookie(key, filter) {
    var d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = key + "=" + filter + ";" + expires + ";path=/";
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}


function getFilterCookie(key) {
    var name = key + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var figures = document.querySelectorAll('figure');

function deBounce(func) {
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 30, event);
    }
};

function fixTriangles(figures) {
    if (figures) {
        figures.forEach(function (el) {
            var x = el.offsetWidth;
            var y = el.offsetHeight;

            el.style.setProperty('--y', + y + 'px');
            el.style.setProperty('--x', + x + 'px');
        });

    }
};


document.addEventListener('DOMContentLoaded', fixTriangles(figures));
window.addEventListener('resize', deBounce(function (e) {
    fixTriangles(figures);
}));



; (function ($) {
    /**
    * @namespace Global main
    */
    revide.main = (function () {
        return function () {
            var pub = {},
                defaults = {
                    menu: {
                        scrollDownOffset: 100,
                        scrollUpOffset: 150
                    },
                    scrollTo: {
                        offset: -70,
                        animationSpeed: 900
                    }
                },
                screenSize,
                elementSelectors = {
                    navMobile: 'header.mobile',
                    navDesktop: 'header.desktop'
                },
                $elements = {}

            // ******************************
            // PUBLIC METHODS
            // ******************************

            pub.init = function () {
                setupElements();
                delegateEvents();



                if ($(document).width() > 1024) {
                    $(window).on('scroll', function () {
                        scrollSpy();
                    });
                }

                $('.st-content').on('scroll', function () {
                    scrollSpy();
                });

                // Hamburger animation
                $('.mobile-menu').bind("touchstart", function () {
                    $('#hamburger-icon').addClass('open');
                });

                $('.st-pusher').bind("touchstart", function () {
                    $('#hamburger-icon').removeClass('open');
                });

                $('.show-user-dropdown-mobile').click(function () {
                    $('nav.user-dropdown').slideToggle(200);
                });

                $('.show-user-dropdown').click(function () {
                    $('nav.user-dropdown').slideToggle(200);
                });

                $('.show-login-mobile').click(function () {
                    $('nav.login').slideToggle(200);
                });

                //$('div.newsletter-flarp a').click(function () {
                //    $('div.newsletter-blob-form').toggleClass('show');
                //});

                $('a.close-newsletter').click(function () {
                    $('div.newsletter-blob-form').removeClass('show');
                });

                var cookieHeight = $('div.cookie-info').outerHeight();
                $('body').css('paddingTop', cookieHeight);

                // Close cookie info
                $('div.cookie-info a').click(function () {
                    //$('div.cookie-info').addClass('hide');
                    $('div.cookie-info').fadeOut();
                    $('body').css('paddingTop', '0');

                    document.cookie = "customerfirstvisit=1; expires=Thu, 01 Jan 2070 00:00:00 UTC; path=/";
                });



                // SHOW SEARCH
                $('a.show-search').click(function () {
                    $('div.search-wrapper').slideToggle(150);
                    $('a.show-search').toggleClass('active');
                    $('a#btnSearch ').toggleClass('active');
                    $('input#search ').focus();

                    if ($('div.search-wrapper').is(':visible')) {
                        $(document).on('keyup', function (evt) {
                            if (evt.keyCode == 27) {
                                $('div.search-wrapper').slideUp(150);
                                $('a.show-search').removeClass('active');
                                $('a#btnSearch ').removeClass('active');
                            }
                        });
                    }
                });

                // Responsive options
                var responsiveCarouselOptions = [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        speed: 400,
                        useTransform: false,
                        useCSS: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 100,
                        useTransform: false,
                        useCSS: false,
                    }
                }];


                $(".customer-carousel").slick({
                    // Normal options
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    useTransform: true,
                    useCSS: true,
                    cssEase: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
                    speed: 600,
                    appendArrows: '.slider-navi-second',
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 400,
                            useTransform: false,
                            useCSS: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 100,
                            useTransform: false,
                            useCSS: false,
                        }
                    }]
                });

                $(".icon-carousel").slick({

                    // Normal options
                    infinite: true,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    useTransform: true,
                    useCSS: true,
                    cssEase: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
                    speed: 600,
                    appendArrows: '.slider-navi',
                    responsive: responsiveCarouselOptions
                });

                //BLOG PAGE - TOP SLIDER
                $(".inspiration-hero").slick({
                    arrows: false,
                    dots: true,
                    autoplay: true
                });

                //BLOG PAGE - SMOOTH SCROLL
                $(".inspiration-header nav a").click(function (event) {
                    if (
                        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                        &&
                        location.hostname == this.hostname
                    ) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            event.preventDefault();
                            $('html, body').animate({
                                scrollTop: target.offset().top
                            }, 1000, function () {
                                // Callback after animation
                                // Must change focus!
                                var $target = $(target);
                                $target.focus();
                                if ($target.is(":focus")) { // Checking if the target was focused
                                    return false;
                                } else {
                                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                    $target.focus(); // Set focus again
                                };
                            });
                        }
                    }
                });

                $(".employees_filter select").select2({
                    minimumResultsForSearch: -1,
                    width: 'style',
                    dropdownCssClass: "employee_dropdown"
                });
                $('.employees_filter select').select().val();



                $('.employees_filter select').on('select2:select', function (e) {

                    var data = e.params.data;
                    var select = $("#select2-filter_section-container").attr("title");
                    var select2 = $("#select2-filter_office-container").attr("title");

                    $(".employee_subheader").html(select);
                    $.ajax({
                        url: "/umbraco/api/Ajax/GetCoworkers/",
                        type: "GET",
                        data: { city: select2, deparment: select }, //self.maxItemsPerPage },
                        dataType: "json",
                        success: function (returnData) {
                            if (returnData != "") {
                                //var currentNewsList = ko.mapping.fromJSON(returnData);
                                var regX = /(<([^>]+)>)/ig;
                                var regSpace = "/\s/g";
                                var html = "";

                                var palle = returnData.Data.toString().split('---');
                                //var ol = returnData.Data.toString().Split(',');
                                //alert(ol);
                                //alert(ol[0]);
                                //alert(ol[1]);
                                var htmlInformation = "";
                                var currentNewsList = JSON.parse(returnData.Data.toString());

                                //for (var i = 0; i < currentNewsList.length; i++) {

                                //	html += '<li class="gridder-list" data-griddercontent="#' + currentNewsList[i].Name.replace(/\s/g, "") + '"><div class="image"><img src="' + currentNewsList[i].ImageLink + '" /></div><span class="name">' + currentNewsList[i].Name + '</span><span class="position">' + currentNewsList[i].Position + '</span></li>';
                                //	htmlInformation += "<div id='" + currentNewsList[i].Name.replace(/\s/g, "")  + "' class='gridder-content'><img src='" + currentNewsList[i].ImageLink + "' /><div class='emplyee_content'>'" + currentNewsList[i].Text.replace(regX, ""); + "</div></div>";
                                //}

                                $(".cont").html("");
                                $(".cont").append(palle[0]);

                                //$(".employee-gridder").html("");
                                //$(".employee-gridder").html(html);
                                //$(".employee-gridder").after("");
                                $(".information").html("");
                                $(".information").html(palle[1]);

                                $('.employee-gridder').gridderExpander({
                                    showNav: false,
                                    scroll: false,
                                    animationEasing: false,
                                    animationSpeed: 300,
                                    onContent: function () {
                                        fixWidth();

                                        $(window).on('resize', function () {
                                            fixWidth();
                                        });

                                        function fixWidth() {
                                            var offset = $('.gridder').offset();
                                            var winWidth = $(window).innerWidth();
                                            $('.gridder-show').css('marginLeft', '-' + offset.left + 'px');
                                            $('.gridder-show').css('width', winWidth + 'px');
                                            setTimeout(function () {
                                                $('.gridder-show').css('opacity', 1);
                                            }, 1);
                                        }
                                    }
                                });

                                $('.employee-gridder .gridder-list').matchHeight();


                                // Run match height script
                                pub.matchHeights();


                                //self.startNewsList(self.startNewsList().concat(currentNewsList()));
                                //alert(currentNewsList);

                            }
                            //if (returnData.Data.End === true) {
                            //	self.disabled(true);
                            //} else {
                            //	self.disabled(false);
                            //}


                        },
                        error: function (e) {
                            alert(e.statusText + ": " + e.responseText);
                            console.log(e.statusText + ": " + e.responseText); //todo: better error handling
                        },
                        complete: function () {

                        }
                    });


                });

                $('.employee-gridder').gridderExpander({
                    showNav: false,
                    scroll: false,
                    animationEasing: false,
                    animationSpeed: 300,
                    onContent: function () {
                        fixWidth();

                        $(window).on('resize', function () {
                            fixWidth();
                        });

                        function fixWidth() {
                            var offset = $('.gridder').offset();
                            var winWidth = $(window).innerWidth();
                            $('.gridder-show').css('marginLeft', '-' + offset.left + 'px');
                            $('.gridder-show').css('width', winWidth + 'px');
                            setTimeout(function () {
                                $('.gridder-show').css('opacity', 1);
                            }, 1);
                        }
                    }
                });

                $('.employee-gridder .gridder-list').matchHeight();


                // Run match height script
                pub.matchHeights();
            };




            // ******************************
            // PRIVATE METHODS
            // ******************************

            var scrollSpy = function () {

                height = $(window).scrollTop();
                heightMob = $('.st-content').scrollTop();


                if ($(document).width() <= 1024) {
                    if (heightMob > defaults.menu.scrollDownOffset) {
                        $('div.newsletter-blob').addClass('hide');
                        $('div.newsletter-blob-form').removeClass('show');
                        $('div.video-blob').addClass('hide');
                    }
                    else if (heightMob < defaults.menu.scrollUpOffset) {
                        $('div.newsletter-blob').removeClass('hide');
                        $('div.video-blob').removeClass('hide');
                    }
                } else {

                    // Animate desktop menu
                    if (height > defaults.menu.scrollDownOffset && !$($elements.navDesktop).hasClass("campaign-page")) {
                        $elements.navDesktop.addClass('small');
                        $('div.newsletter-blob').addClass('hide');
                        $('div.newsletter-blob-form').removeClass('show');

                        $('div.video-blob').addClass('hide');

                        // Hide search input on scroll
                        if ($('div.search-wrapper').is(':visible')) {
                            $('div.search-wrapper').slideUp(150);
                            $('a.show-search').removeClass('active');
                            $('a#btnSearch ').removeClass('active');
                        }
                    }
                    else if (height < defaults.menu.scrollUpOffset) {
                        $elements.navDesktop.removeClass('small');
                        $('div.newsletter-blob').removeClass('hide');
                        $('div.video-blob').addClass('hide');

                    }
                }

                // Parallax top image on start page
                if ($(document).width() > 1024) {
                    $('section.top-image').css('background-position', 'top ' + -height / 4 + 'px center');
                }

            };

            var setupElements = function () {
                $.each(elementSelectors, function (el, selector) {
                    $elements[el] = $(selector);
                });
            };

            var delegateEvents = function () {
            };


            pub.getFreyaNews = function (jsonUrl, readMorePage) {
                // var jsonUrl = 'http://api.freyanews.com/rss/0.1/hypergene.freyanews.com/kundberattelser';
                // var outputHtml = '<h1>Hypergene Nyheter</h1><br>';
                // var readMorePage = "/sv/inspiration/kundberattelser/"
                var outputTarget = "#freya-news";
                var outputHtml = '';

                $.ajax({
                    type: 'GET',
                    url: jsonUrl,
                    async: false,
                    jsonpCallback: 'callback',
                    contentType: "application/json",
                    dataType: 'jsonp',
                    success: function (json) {
                        //console.log(JSON.stringify(json.articles));

                        $.each(json.articles, function (i, article) {
                            outputHtml +=
                                '<div>\
                                    <div>\
                                        <img src="//static.freyanews.com/images/news/760x400/' + article.filename + '" alt="">\
                                    </div>\
                                    <div>\
                                        <h2>' + article.header + '</h2>\
                                        <p>' + article.excerpt + '<br><a href="' + readMorePage + article.header_url + '">L&auml;s mer</a></p>\
                                   </div>\
                                </div>';
                        });

                        $(outputTarget).html(outputHtml);
                    },
                    error: function (e) {
                        $(outputTarget).html(e.message);
                    }
                });
            };

            // Matchheight scripts
            pub.matchHeights = function () {

                /*if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                    // setTimeout fix for Safari matchHeight
                    setTimeout(function() {
                        $('section.news-start .columns').matchHeight();
                        $('section.related .box').matchHeight();
                        $('section.seminars .box').matchHeight();
                    }, 200);
 
                    if ($(document).width() <= 1024) {
                        $(window).bind('orientationchange', function(event) {
                            location.reload();
                        });
                    }
 
                } else {
                    $('section.promoboxes-start .promobox > div').matchHeight();
                    $('section.news-start .columns').matchHeight();
                    $('section.related .box').matchHeight();
                    $('section.seminars .box').matchHeight();
                }*/

                $('section.promoboxes-start .promobox > div').matchHeight();
                //$('section.news-start .columns').matchHeight();
                $('section.related .box').matchHeight();
                $('section.seminars .box').matchHeight();
                $('.freya-item').matchHeight();
            };

            return pub;
        }();

    })();

    $(document).ready(revide.main.init);

    $(window).resize(function () {
        revide.main.matchHeights();
    });

})(jQuery);

// TOGGLE MOBILE MENU LEVELS
function toggleChild(obj) {
    $(obj).nextAll("ul:first").slideToggle(200);
    $(obj).toggleClass("minus");
}

function toggleChooseLanguage(obj) {
    $(obj).nextAll("ul:first").slideToggle(200);
    $('.toggle-lev').toggleClass("minus");
}

// Used for setting browser specific css with SASS mixin
document.documentElement.setAttribute("data-browser", navigator.userAgent);